// var countryClick = document.querySelectorAll(".league-list-wrapper .country-list");
// countryClick.forEach(function(country) {
//   country.addEventListener('click', () => {
//     const countryName = country.getAttribute('data-value').toLowerCase();
//     console.log("countryName",countryName);
//       window.location.href = `/${countryName}`;
//   });
// });

// $('body').find('.currency_selector_flag ul.all_currency li').each(function(){
 //    $(this).on('click', function(){
 //      var value = $(this).attr('value');
 //      var image_src = $(this).find('img').attr('src');
 //      // alert(value);
 //      // alert(image_src);
 //      $('body').find('.currency_selector_flag .slected_currency img').attr('src',image_src);
 //      $('body').find('.currency_selector_flag .slected_currency span').html(value);
      
 //      var currentUrl = new URL(window.location.href);
 //      currentUrl.searchParams.set('currency',value);
 //      window.location.href = currentUrl.href;
 //    });
 //  });

// faqs
document.addEventListener("DOMContentLoaded", () => {
  // Handle FAQ buttons
  const buttons = document.querySelectorAll(".faq-btn");

  buttons.forEach((button) => {
    button.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent default anchor behavior

      // Remove the active class from all buttons
      buttons.forEach((btn) => btn.classList.remove("active"));

      // Add the active class to the clicked button
      button.classList.add("active");

      // Redirect to the URL specified in the href attribute
      window.location.href = button.getAttribute("href");
    });
  });
});

// faq content scroll 

 document.addEventListener('DOMContentLoaded', function() {
  const faqButtons = document.querySelectorAll('.faq-btn');

  faqButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const targetTitle = this.getAttribute('data-btn-title');
      const targetSection = document.querySelector(`[data-faq-title="${targetTitle}"]`);

      if (targetSection) {
        //console.log("same******");
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});


  var navigation = document.querySelectorAll('[data-btn-title]');
  navigation.forEach(nav =>{         
    nav.addEventListener("click",function (event) {
      // console.log("nav",nav);
      // console.log(event);
      // console.log($(this.hash))
      smoothScroll($(this.hash));
    });
  
  });

function smoothScroll(target) {
    console.log("target",target) ;
  var header_hight = (document.querySelector('sticky-header').offsetHeight + 10) || 150;
    $("body,html").animate(
        {
            scrollTop: target.offset().top - header_hight
        },
        300
    );
}

$(document).ready(function() {  
  
  mainSlideshowHome();
  innerSlideHome();
  iconWithText(); 
  featuredCollection();  
  momentList();
  satisfactionList();
  termsList();
  footerService();  

  const faq_page_accordionBtns = document.querySelectorAll(
  ".faq_accordion .accordion"
);

faq_page_accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
      this.nextElementSibling.style.maxHeight = "0px";
    } else {
      $(".faq_accordion .accordion").removeClass("is-open");
      $(".faq_accordion .accordion-content").css("max-height", "0px");
      $(this).addClass("is-open");
      let content = this.nextElementSibling;
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };
});

const faq_accordionBtns = document.querySelectorAll(
  ".faq-page_main_wrapper .accordion"
);

faq_accordionBtns.forEach((accordion) => {
  accordion.onclick = function () {
    if ($(this).hasClass("is-open")) {
      $(this).removeClass("is-open");
      this.nextElementSibling.style.maxHeight = "0px";
    } else {
      $(".faq-page_main_wrapper .accordion").removeClass("is-open");
      $(".faq-page_main_wrapper .accordion-content").css("max-height", "0px");
      $(this).addClass("is-open");
      let content = this.nextElementSibling;
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };
});



  
  // faq content scroll 
  
  const faqButtons = document.querySelectorAll('.faq-btn');

  faqButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const targetTitle = this.getAttribute('data-btn-title');
      const targetSection = document.querySelector(`[data-faq-title="${targetTitle}"]`);

      if (targetSection) {
        //console.log("same******");
        targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

   $('.dropdown-content .blog-btn').click(function() {
    // Hide the dropdown menu when a button is clicked
    $('.dropdown-content').css('display', 'none');
    var tagName = $(this).attr('data-title-set');
    console.log("tagName",tagName);
    $('.dropdown-button').text(tagName);
  });



  $(document).ready(function() {
      $('.popup-with-form').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#name',
  
          // When elemened is focused, some mobile browsers in some cases zoom in
          // It looks not nice, so we disable it:
          callbacks: {
              beforeOpen: function() {
                  if($(window).width() < 700) {
                      this.st.focus = false;
                  } else {
                      this.st.focus = '#name';
                  }
              }
          }
      });
  });
  
  
});


function mainSlideshowHome() { 
  if(!document.querySelector('.main-slideshow-wrapper .mainSlideshow')) return;
  var swiper = new Swiper(".mainSlideshow", {
    navigation: {
      nextEl: ".mainButton-next",
      prevEl: ".mainButton-prev",
    },
  });  
}


function innerSlideHome() { 
  if(!document.querySelector('.main-slideshow-wrapper .mainSlideshow')) return;
  var swiper = new Swiper(".slideshowInner", {
    navigation: {
      nextEl: ".innerButtion-next",
      prevEl: ".innerButtion-prev",
    },
  });  
}

function iconWithText() { 
  if(!document.querySelector('.icon-with-text-wrapper .iconTextSlider')) return;
  
  var swiper = new Swiper(".iconTextSlider", {    
    slidesPerView: 4,
    spaceBetween: 30,
      breakpoints: {  
        10: {
          slidesPerView: 1,
          spaceBetween: 20,
          initialSlide: 1,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        450: {
          slidesPerView: 1,
          spaceBetween: 20,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
  });    
}


function featuredCollection() { 
  if(!document.querySelector('.featured-collection-wrapper .featuredCollection')) return;

  let desktopSliderPerView = Number(document.querySelector('.featuredCollection').dataset.sliderPerShow || 4);
  var swiper = new Swiper(".featuredCollection", {  
    navigation: {
      nextEl: ".featuredButtion-next",
      prevEl: ".featuredButtion-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    spaceBetween: 30,
      breakpoints: {
        10: {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 1,
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: desktopSliderPerView,
          spaceBetween: 30,
        },
      },
  });    
}



function relatedCollection() { 
  if(!document.querySelector('.related-product-wrapper .relatedCollection')) return;

  let relatedDesktopSliderPerView = Number(document.querySelector('.relatedCollection').dataset.sliderPerShow || 4);
  var swiper = new Swiper(".relatedCollection", {  
    navigation: {
      nextEl: ".relatedButtion-next",
      prevEl: ".relatedButtion-prev",
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    spaceBetween: 30,
      breakpoints: {
        10: {
          slidesPerView: 2,
          spaceBetween: 20,
          initialSlide: 1,
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1199: {
          slidesPerView: relatedDesktopSliderPerView,
          spaceBetween: 30,
        },
      },
  });    
}



function momentList() { 
  if(!document.querySelector('.greatest-final-moments-wrapper .momentList')) return;
  
  var swiper = new Swiper(".momentList", {  
    slidesPerView: 3,    
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".momentButtion-next",
      prevEl: ".momentButtion-prev",
    },     
    spaceBetween: 30,
      breakpoints: {
        10: {
          slidesPerView: 1,
          spaceBetween: 15,
          initialSlide: 1,
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 20,
        },        
      },
  });    
}

function satisfactionList() { 
  if(!document.querySelector('.customer-satisfaction-wrapper .satisfactionList')) return;
  
  var swiper = new Swiper(".satisfactionList", {  
    slidesPerView: 3,     
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".satisfactionButtion-next",
      prevEl: ".satisfactionButtion-prev",
    },     
    spaceBetween: 70,
      breakpoints: {
        10: {
          slidesPerView: 1,
          spaceBetween: 15,
          initialSlide: 1,
        },
        450: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        750: {
          slidesPerView: 2,
          spaceBetween: 40,
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 70,
        },        
      },
  });    
}



function termsList() { 
  if(!document.querySelector('.most-popular-teams-wrapper .termsList')) return;
  
  var swiper = new Swiper(".termsList", {  
    slidesPerView: 4,     
    spaceBetween: 30,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      10: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 20,         
      },
      749: {
        slidesPerView: "auto",
        centeredSlides: true,
        spaceBetween: 30,
      },       
      750: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      992: {
        slidesPerView: 4,
        spaceBetween: 30,
      },
    },
  });    
}


function footerService() { 
  if(!document.querySelector('.site-footer .footerService')) return;
  
  var swiper = new Swiper(".footerService", {  
    slidesPerView: 4,
    spaceBetween: 30,
      breakpoints: {
        10: {
          slidesPerView: "auto",         
          spaceBetween: 20,             
        },
        749: {
          slidesPerView: 2,
          spaceBetween: 30,          
        },
        991: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
        1199: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },
  });    
}



if (Shopify.designMode) {
   document.addEventListener("DOMContentLoaded", function() {
    document.addEventListener('shopify:section:load', function(){
      
     const mainSlideshowHomeSection = event.target.closest('.main-slideshow-wrapper') || null;
      if(mainSlideshowHomeSection){
        mainSlideshowHome();
      }
      
     const innerSlideHomeSection = event.target.closest('.main-slideshow-wrapper') || null;
      if(innerSlideHomeSection){
        innerSlideHome();
      }

      const iconWithTextWrapper = event.target.closest('.icon-with-text-wrapper') || null;
      if(iconWithTextWrapper){
        iconWithText();
      }

      const featuredCollectionWrapper = event.target.closest('.featured-collection-wrapper') || null;
      if(featuredCollectionWrapper){
        featuredCollection();
      }

      const momentListWrapper = event.target.closest('.greatest-final-moments-wrapper') || null;
      if(momentListWrapper){
        momentList();
      } 

      const satisfactionListWrapper = event.target.closest('.customer-satisfaction-wrapper') || null;
      if(satisfactionListWrapper){
        satisfactionList();
      } 

      const termsListWrapper = event.target.closest('.most-popular-teams-wrapper') || null;
      if(termsListWrapper){
        termsList();
      }
      
      const footerServiceWrapper = event.target.closest('.site-footer') || null;
      if(footerServiceWrapper){
        footerService();
      }

     const relatedCollectionWrapper = event.target.closest('.related-product-wrapper') || null;
      if(relatedCollectionWrapper){
        relatedCollection();
      }

      
    });
  });
}



// PASSWORD SHOW AND HIDE start

class ShowPassword extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.show_password.bind(this));
  }

  show_password(event) {
    event.preventDefault();
    this.closest('.field').querySelector('input').setAttribute('type', this.closest('.field').querySelector('input').getAttribute('type') === 'password' ? 'text' : 'password');
    this.classList.toggle('show-password');
  }
}

customElements.define('show-password', ShowPassword);
// PASSWORD SHOW AND HIDE END



//  For Footer part
 $(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.js-acc-single-trigger');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }
   
if ($(window).width() < 750){  
  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
      $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.accordion-single-content').not($next).slideUp().parent().removeClass('open');
    };
  } 
}
  var accordion = new Accordion($('#accordion'), false);
});

// timer section 
document.addEventListener("DOMContentLoaded", function() {
  var dealTimeSection = document.querySelector(".timer-section");
  if (dealTimeSection) {
    // dealTimeSections.forEach(function(dealTimeSection, index) {      
      var dealTimeElem = dealTimeSection.querySelector(".deal-time");
      var dealTime = dealTimeElem?.getAttribute("deal-time"); 
   

  // Convert HH:MM:SS to total seconds
      function timeStringToSeconds(timeString) {
        let [hours, minutes, seconds] = timeString.split(':').map(Number);
        return hours * 3600 + minutes * 60 + seconds;
      }

  // Get the remaining time, accounting for elapsed time and deal time changes
      function getRemainingTime(timerKey, totalSeconds, currentDealTime) {
        const storedStartTime = localStorage.getItem('startTime_' + timerKey);
        const storedTotalTime = localStorage.getItem('totalTime_' + timerKey);
        const storedDealTime = localStorage.getItem('dealTime_' + timerKey);

        // If the deal time has changed, reset the timer
        if (storedDealTime !== currentDealTime) {
          localStorage.setItem('dealTime_' + timerKey, currentDealTime);
          localStorage.setItem('startTime_' + timerKey, Math.floor(Date.now() / 1000));
          localStorage.setItem('totalTime_' + timerKey, totalSeconds);
          return totalSeconds; // Reset the timer with new deal time
        }

        if (storedStartTime && storedTotalTime) {
          const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
          const elapsedTime = currentTime - storedStartTime; // Time elapsed since countdown started
          let remainingTime = storedTotalTime - elapsedTime;

          return remainingTime > 0 ? remainingTime : 0; // Ensure non-negative remaining time
        }

        return totalSeconds; // If no stored time, return the total countdown time
      }

   // Start or continue countdown
      function startCountdown(timerKey, totalSeconds) {
        let timeInSeconds = getRemainingTime(timerKey, totalSeconds, dealTime);
        function updateTime() {
          if (timeInSeconds <= 0) {
            clearInterval(timerInterval);
            // Set to 00:00:00 when countdown finishes
            dealTimeSection.querySelector('.hours-tens').textContent = '0';
            dealTimeSection.querySelector('.hours-units').textContent = '0';
            dealTimeSection.querySelector('.minutes-tens').textContent = '0';
            dealTimeSection.querySelector('.minutes-units').textContent = '0';
            dealTimeSection.querySelector('.seconds-tens').textContent = '0';
            dealTimeSection.querySelector('.seconds-units').textContent = '0';
            return;
          }

          timeInSeconds--;

          const hours = Math.floor(timeInSeconds / 3600);
          const minutes = Math.floor((timeInSeconds % 3600) / 60);         
          const seconds = timeInSeconds % 60;       

          dealTimeSection.querySelector('.hours-tens').textContent = Math.floor(hours / 10);
          dealTimeSection.querySelector('.hours-units').textContent = hours % 10;
  
          dealTimeSection.querySelector('.minutes-tens').textContent = Math.floor(minutes / 10);
          dealTimeSection.querySelector('.minutes-units').textContent = minutes % 10;

          dealTimeSection.querySelector('.seconds-tens').textContent = Math.floor(seconds / 10);
          dealTimeSection.querySelector('.seconds-units').textContent = seconds % 10;
        }

        const timerInterval = setInterval(updateTime, 1000);

        // Store the start time and total time in localStorage if it's a new timer
        if (!localStorage.getItem('startTime_' + timerKey)) {
          const currentTime = document.querySelector("[current-time]").getAttribute("current-time"); // Current time in seconds
          console.log("currentTime",currentTime);
          localStorage.setItem('startTime_' + timerKey, currentTime);
          localStorage.setItem('totalTime_' + timerKey, totalSeconds);
          localStorage.setItem('dealTime_' + timerKey, dealTime);
        }
      }
  
      const index = 1; // Example index
      const timerKey = 'timer_' + index;

      const totalSeconds = timeStringToSeconds(dealTime);
      startCountdown(timerKey, totalSeconds);
   }
});
  




(function() { 
const popup_open = document.querySelectorAll('[data-popup-open]') || null;
  if(popup_open){
      popup_open.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = document.querySelector(event.target.hash) || null;
        console.log(main_popup);
          if(!main_popup) return;
                 main_popup.classList.add("open"); 
                 document.body.classList.add("popup_open");
        });
     });
  }  

  const popup_close = document.querySelectorAll('[data-popup-close]') || null;
  if(popup_close){
      popup_close.forEach(b => {
      b.addEventListener("click", (event) => {
        event.preventDefault();
           const main_popup = event.target.closest('[data-poup]') || null;
          if(!main_popup) return;
                 main_popup.classList.remove("open"); 
                 document.body.classList.remove("popup_open");
        });
     });
  } 
  })();
 